"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableFiltersButton = void 0;
exports.setFilter = setFilter;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
var _CategoryOfProductFilterField = require("./filtersComponents/CategoryOfProductFilterField");
var _styles = require("@material-ui/core/styles");
var _SpecificitiesFieldFilter = require("./filtersComponents/SpecificitiesFieldFilter");
var _AddFilterButton = require("./filtersComponents/AddFilterButton");
var _tableHooks = require("../../tableHooks");
var _ApplyAndCancelButtons = require("./sharedComponents/ApplyAndCancelButtons");
var _MultiSelectField = require("./filtersComponents/MultiSelectField");
var _OptionsFilter = require("./filtersComponents/OptionsFilter");
var _excluded = ["tableHeadColumns", "appliedFilter", "setAppliedFilter", "formattedFilters", "setFormattedFilters", "filters", "setFilters", "handleClose"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      minWidth: "200px",
      padding: "1rem"
    },
    chipsWrapper: {
      display: "flex",
      flexWrap: "wrap",
      marginBottom: "0.5rem",
      maxWidth: "20rem"
    },
    chip: {
      margin: "0rem 0.5rem 0.5rem 0rem",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    selectField: {
      width: "100%",
      marginTop: "0.5rem"
    },
    selectFieldDisplay: {
      maxWidth: "250px",
      whiteSpace: "pre-wrap"
    },
    wrapper: {
      marginTop: "0.5rem"
    },
    bottomButtonsWrapper: {
      paddingTop: "0.75rem"
    },
    popover: {
      overflow: "auto"
    }
  };
});
function setFilter(_ref) {
  var allFilters = _ref.allFilters,
    setAllFilters = _ref.setAllFilters,
    columnName = _ref.columnName,
    filterLabel = _ref.filterLabel,
    filterName = _ref.filterName,
    filterValue = _ref.filterValue;
  var newAllFilters = [];
  if (allFilters.some(function (filter) {
    return filter.columnName === columnName;
  })) {
    newAllFilters = allFilters.map(function (filter) {
      if (filter.columnName === columnName) {
        return _objectSpread(_objectSpread({}, filter), {}, {
          label: filterLabel,
          filterName: filterName,
          filterValue: filterValue
        });
      }
      return filter;
    });
  } else {
    newAllFilters = [].concat(_toConsumableArray(allFilters), [{
      label: filterLabel,
      filterName: filterName,
      filterValue: filterValue,
      columnName: columnName
    }]);
  }
  setAllFilters(newAllFilters);
  return newAllFilters;
}
var TableFiltersButton = function TableFiltersButton(_ref2) {
  var tableHeadColumns = _ref2.tableHeadColumns,
    appliedFilter = _ref2.appliedFilter,
    setAppliedFilter = _ref2.setAppliedFilter,
    setFormattedFilters = _ref2.setFormattedFilters,
    formattedFilters = _ref2.formattedFilters,
    filters = _ref2.filters,
    setFilters = _ref2.setFilters;
  var classes = useStyle();
  var _usePopover = (0, _tableHooks.usePopover)(),
    anchorEl = _usePopover.anchorEl,
    open = _usePopover.open,
    handleOpen = _usePopover.handleOpen,
    handleClose = _usePopover.handleClose;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleOpen,
    variant: "outlined",
    startIcon: /*#__PURE__*/_react.default.createElement(_core.Icon, null, "filter_list_icon")
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "table_Filtres",
    defaultMessage: "table_Filtres"
  })), /*#__PURE__*/_react.default.createElement(_core.Popover, {
    PaperProps: {
      style: {
        maxWidth: "288px"
      }
    },
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    className: classes.popover,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(TableFilters, {
    tableHeadColumns: tableHeadColumns,
    appliedFilter: appliedFilter,
    setAppliedFilter: setAppliedFilter,
    setFormattedFilters: setFormattedFilters,
    formattedFilters: formattedFilters,
    filters: filters,
    setFilters: setFilters,
    handleClose: handleClose
  })));
};
exports.TableFiltersButton = TableFiltersButton;
var TableFilters = (0, _Translations.injectIntl)(function (_ref3) {
  var tableHeadColumns = _ref3.tableHeadColumns,
    appliedFilter = _ref3.appliedFilter,
    setAppliedFilter = _ref3.setAppliedFilter,
    formattedFilters = _ref3.formattedFilters,
    setFormattedFilters = _ref3.setFormattedFilters,
    filters = _ref3.filters,
    setFilters = _ref3.setFilters,
    handleClose = _ref3.handleClose,
    props = _objectWithoutProperties(_ref3, _excluded);
  var classes = useStyle();
  // this state is used to store the value to filter by (name, price, quantity, etc)
  var _useState = (0, _react.useState)(tableHeadColumns[0]),
    _useState2 = _slicedToArray(_useState, 2),
    filteredValue = _useState2[0],
    setFilteredValue = _useState2[1];
  // this state is used to store the filter operator options (is, is not, is null, is not null, etc)
  var _useFilterOptions = (0, _tableHooks.useFilterOptions)(filteredValue.type),
    filterOption = _useFilterOptions.filterOption,
    setFilterOption = _useFilterOptions.setFilterOption;
  // this state is used to store the filters to be applied
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    allFilters = _useState4[0],
    setAllFilters = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    term = _useState6[0],
    setTerm = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    values = _useState8[0],
    setValues = _useState8[1];
  var handleAddFilterRef = (0, _react.useRef)(null);
  var isFilterOptionNull = ["3", "4"].includes(filterOption.id);
  var handleSelectFilteredValue = (0, _react.useCallback)(function (event) {
    var newFilteredValue = tableHeadColumns.find(function (_ref4) {
      var value = _ref4.value;
      return value === event.target.value;
    });
    var newFilterOption = _tableHooks.FILTER_OPTIONS.find(function (option) {
      return option.type === newFilteredValue.type;
    }).options[0];
    setFilteredValue(newFilteredValue);
    setFilterOption(newFilterOption);
    setTerm("");
    setValues([]);
  }, [setFilterOption, setValues, tableHeadColumns]);
  var handleTerm = (0, _react.useCallback)(function (event) {
    setTerm(event.target.value);
  }, []);
  var handleAddFilter = (0, _react.useCallback)(function () {
    var formatMessage = props.intl.formatMessage;
    var _term = term;
    var isString = typeof filteredValue.value === 'string';
    if (filteredValue.type === "boolean") {
      var booleanFilterValueLabel = _tableHooks.FILTER_OPTIONS.find(function (option) {
        return option.type === filteredValue.type;
      }).values.find(function (_ref5) {
        var value = _ref5.value;
        return value === term;
      }).label;
      _term = formatMessage({
        id: booleanFilterValueLabel,
        defaultMessage: booleanFilterValueLabel
      });
    } else if (filteredValue.type === "list") {
      var listFilterValueLabel = filteredValue.options.filter(function (_ref6) {
        var value = _ref6.value;
        return values.includes(value);
      }).map(function (_ref7) {
        var label = _ref7.label;
        return formatMessage({
          id: label,
          defaultMessage: label
        });
      }).join(", ");
      _term = listFilterValueLabel;
    }
    var filterLabel = "".concat(formatMessage({
      id: filteredValue.label,
      defaultMessage: filteredValue.label
    }), " ").concat(formatMessage({
      id: filterOption.label,
      defaultMessage: filterOption.label
    }), " ").concat(_term);
    if (isFilterOptionNull || term || values.length) {
      // for applied filter object
      var filterName = "".concat(filterOption.symbol).concat(isString ? filteredValue.value : filteredValue.filtreValue);
      var filterValue = term ? filterOption.label === "contient" ? "%".concat(term, "%") : term : values.length ? values : "null";
      // reset filter option to default
      setFilterOption(_tableHooks.FILTER_OPTIONS.find(function (option) {
        return option.type === filteredValue.type;
      }).options[0]);
      setValues([]);
      setTerm("");
      return setFilter({
        allFilters: allFilters,
        setAllFilters: setAllFilters,
        columnName: isString ? filteredValue.value : filteredValue.filtreValue,
        filterLabel: filterLabel,
        filterName: filterName,
        filterValue: filterValue
      });
    }
    return allFilters;
  }, [allFilters, filterOption, filteredValue, isFilterOptionNull, props, setFilterOption, term, values, setValues]);
  var handleApplyFilterButton = (0, _react.useCallback)(function () {
    var newAppliedFilter = _objectSpread({}, appliedFilter);
    var newFilters = _objectSpread({}, filters);
    var newFormattedFilters = _toConsumableArray(formattedFilters);
    var newAllFilters = (["category.name", "specificity"].includes(filteredValue.value) ? handleAddFilterRef.current() : handleAddFilter()) || [];
    newAllFilters.forEach(function (filter) {
      var filterName = filter.filterName,
        filterValue = filter.filterValue,
        columnName = filter.columnName;
      if (newFilters[columnName]) {
        delete newAppliedFilter[newFilters[columnName]];
        newFormattedFilters = newFormattedFilters.map(function (formattedFilter) {
          if (formattedFilter.columnName === columnName) {
            return filter;
          }
          return formattedFilter;
        });
      } else {
        newFormattedFilters.push(filter);
      }
      newFilters[columnName] = filterName;
      newAppliedFilter[filterName] = filterValue;
    });
    setFormattedFilters(newFormattedFilters);
    setAppliedFilter(newAppliedFilter);
    setFilters(newFilters);
    handleClose();
  }, [appliedFilter, filters, handleClose, setAppliedFilter, setFormattedFilters, setFilters, formattedFilters, filteredValue, handleAddFilter]);
  var handleDelete = (0, _react.useCallback)(function (toRemoveFilter) {
    var newAllFilters = allFilters.filter(function (filter) {
      return filter.label !== toRemoveFilter;
    });
    setAllFilters(newAllFilters);
  }, [allFilters]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.chipsWrapper
  }, allFilters.map(function (_ref8) {
    var label = _ref8.label;
    return /*#__PURE__*/_react.default.createElement(_core.Chip, {
      className: classes.chip,
      key: label,
      label: label,
      title: label,
      onDelete: function onDelete() {
        return handleDelete(label);
      }
    });
  })), /*#__PURE__*/_react.default.createElement(_core.Select, {
    className: classes.selectField,
    variant: "outlined",
    value: filteredValue.value,
    onChange: handleSelectFilteredValue
  }, tableHeadColumns.map(function (_ref9) {
    var label = _ref9.label,
      value = _ref9.value,
      filtrable = _ref9.filtrable;
    return filtrable ? /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: value,
      value: value
    }, props.intl.formatMessage({
      id: label,
      defaultMessage: label
    })) : null;
  })), filteredValue.value === "category.name" ? /*#__PURE__*/_react.default.createElement(_CategoryOfProductFilterField.CategoryOfProductFilterField, _extends({
    ref: handleAddFilterRef,
    appliedFilter: appliedFilter,
    allFilters: allFilters,
    setAllFilters: setAllFilters
  }, props)) : filteredValue.value === "specificity" ? /*#__PURE__*/_react.default.createElement(_SpecificitiesFieldFilter.SpecificitiesFieldFilter, _extends({
    ref: handleAddFilterRef,
    allFilters: allFilters,
    setAllFilters: setAllFilters
  }, props)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_OptionsFilter.OptionsFilter, _extends({
    filterType: filteredValue.type,
    filterOption: filterOption,
    setFilterOption: setFilterOption,
    setTerm: setTerm,
    classes: classes
  }, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper
  }, !isFilterOptionNull && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ["boolean", "list"].includes(filteredValue.type) ? filteredValue.type === "boolean" ? /*#__PURE__*/_react.default.createElement(_core.Select, {
    fullWidth: true,
    SelectDisplayProps: {
      className: classes.selectFieldDisplay
    },
    variant: "outlined",
    value: term,
    onChange: handleTerm
  }, _tableHooks.FILTER_OPTIONS.find(function (option) {
    return option.type === filteredValue.type;
  }).values.map(function (_ref10) {
    var label = _ref10.label,
      value = _ref10.value;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: value,
      value: value
    }, props.intl.formatMessage({
      id: label,
      defaultMessage: label
    }));
  })) : /*#__PURE__*/_react.default.createElement(_MultiSelectField.MultiSelectField, {
    valuesToRender: filteredValue.options || [],
    classes: classes,
    setValues: setValues,
    values: values,
    selectProps: {
      renderValue: function renderValue(selected) {
        return selected.map(function (value) {
          return filteredValue.options.find(function (option) {
            return option.value === value;
          }).label;
        }).join(", ") || [];
      }
    }
  }) : /*#__PURE__*/_react.default.createElement(_core.TextField, {
    fullWidth: true,
    type: filteredValue.type === "free" ? "text" : filteredValue.type,
    value: term,
    onChange: handleTerm,
    id: "outlined-basic",
    variant: "outlined"
  })))), /*#__PURE__*/_react.default.createElement("div", null, ["specificity", "category.name"].includes(filteredValue.value) === false && allFilters.length < 5 && /*#__PURE__*/_react.default.createElement(_AddFilterButton.AddFilterButton, {
    isDisabled: !isFilterOptionNull && !term && !values.length,
    handleClick: handleAddFilter
  }), /*#__PURE__*/_react.default.createElement(_ApplyAndCancelButtons.ApplyAndCancelButtons, {
    onCancel: handleClose,
    onApply: handleApplyFilterButton,
    className: classes.bottomButtonsWrapper
  })));
});